<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/kakusan/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>Axit nucleic là gì?<!--何謂核酸？--></h1>
        </div>
      </header>
      <HeaderNav activeLink="kakusan" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Suy nghĩ về sức khỏe ở cấp độ di truyền và tập trung vào<!--從基因層面思考健康而著眼於-->
              <br class="d-block d-md-none"/>
              “axit nucleic”(DNA‧RNA)<!--“核酸”(DNA‧RNA)-->
            </h2>
            <div class="row justify-content-center align-items-center mb-md-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/kakusan/img_about03.jpg"
                  alt
                  class="w-100"
                />
              </div>
              <div class="col-md-6">
                <p>
                  Cơ thể con người chúng ta bao gồm khoảng 37 nghìn tỷ tế bào. Các tế bào 
                  trong cơ thể tập hợp lại để hình thành các cơ quan nội tạng và cơ bắp, 
                  và có một nhân trong mỗi tế bào.
                  <!--我們人類的身體是由大約37兆個細胞組成，
                  身體的細胞會聚集形成我們的內臟與肌肉，而每個細胞中都存在細胞核。-->
                  <br />
                  Bởi vì nó có tính axit trong nhân nên các chất có trong nhân thường được gọi là "axit nucleic".
                  <!--由於在細胞核中呈現酸性，因此存在於核內的物質一般稱之為“核酸”。-->
                  <br />
                  Axit nucleic có thể được chia thành hai loại: axit deoxyribonucleic (DNA) 
                  và axit ribonucleic (RNA). DNA là cơ quan chính của các gen di truyền 
                  truyền các đặc điểm "từ cha mẹ sang con cái và từ tế bào này sang tế bào khác". 
                  RNA chịu trách nhiệm tổng hợp protein dựa trên thông tin di truyền của DNA.
                  <!--核酸可分成去氧核糖核酸(DNA)及核糖核酸(RNA)兩種。DNA是傳達「從父母到子女，從細胞到細胞」特性之遺傳基因的主體。而RNA負責根據DNA的基因信息合成蛋白質。-->
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-3">
                <p>
                  Protein là thành phần quan trọng của cơ, xương, các cơ quan, da và móng tay của con người. 
                  Ngay cả hormone và enzyme trong cơ thể sống cũng là protein. Nó là chất không thể thiếu đối 
                  với cơ thể sống. Tế bào của chúng ta được tái sinh mỗi ngày để duy trì sự sống. Sản xuất đủ 
                  lượng protein cần thiết vào đúng thời điểm là rất quan trọng đối với sức khỏe con người. 
                  Trong quá trình tạo ra các protein này, axit nucleic (DNA và RNA) đóng vai trò cực kỳ quan trọng. 
                  Vì vậy, axit nucleic là thành phần không thể thiếu và quan trọng trong cuộc sống khỏe mạnh của chúng ta, 
                  lĩnh vực nghiên cứu về dinh dưỡng axit nucleic cũng thu hút được sự quan tâm đáng kể.
                  <!--蛋白質是構成人體肌肉、骨骼、臟器、皮膚及指甲等重要成分，甚至生物體內的荷爾蒙、酵素等也都是蛋白質。
                  對生物體來說是不可欠缺的物質。我們的細胞每天都會重新誕生來維持生命。在適當的時候用適當的量來製造所需的蛋白質，
                  對人體的健康是非常重要。而在製造這些蛋白質過程中，核酸(DNA和RNA)發揮極重要的作用。因此，
                  核酸是我們健康生活不可或缺的重要成分，關於核酸營養學的研究領域也相當備受矚目。-->
                </p>
              </div>
              <div class="col-md-12 mt-3">
                <p>
                  DNA là cơ quan chính của các gen di truyền truyền các đặc điểm "từ cha mẹ sang con cái, từ tế bào này 
                  sang tế bào khác". Được gấp thành các nhiễm sắc thể một cách có trật tự và được tìm thấy trong nhân tế bào.
                  <!--DNA是傳達「從父母到子女，從細胞到細胞」特性之遺傳基因的主體。以有條不紊的方式摺疊成染色體存在於細胞核內。-->
                  <br />
                  DNA là một nucleotide bao gồm bốn bazơ A (adenine), T (thymine), G (guanine) và C (cytosine), đường và photphat. 
                  Nó bao gồm 3 tỷ cặp bazơ tạo thành một chuỗi xoắn kép.
                  <!--DNA是由A(腺嘌呤)、T(胸腺嘧啶)、G(鳥嘌呤)、C(胞嘧啶)四種鹼基、糖及磷酸構成的核苷酸，由30億個鹼基對構成雙重螺旋。-->
                  <br />
                  Trong DNA, khu vực chứa thông tin được gọi là bản thiết kế sự sống, được gọi là "gen" và là cơ sở để tổng hợp protein. 
                  Tuy nhiên, “gen” chỉ chiếm 2% tổng số DNA.
                  <!--在DNA中，持有情報訊息的領域稱為生命的設計圖，被稱為「基因」，是合成蛋白質的基礎。但是，「基因」僅佔全體DNA的2%。-->
                </p>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <!-- <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              肩負遺傳信息(生命設計圖) 任務的「DNA」
            </h2>
            <div class="row justify-content-center mb-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/kakusan/img_about04.jpg"
                  alt
                  class="w-100"
                />
              </div>
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/kakusan/img_about05.jpg"
                  alt
                  class="w-100"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-3">
                <p>
                  DNA是傳達「從父母到子女，從細胞到細胞」特性之遺傳基因的主體。以有條不紊的方式摺疊成染色體存在於細胞核內。
                  <br />
                  DNA是由A(腺嘌呤)、T(胸腺嘧啶)、G(鳥嘌呤)、C(胞嘧啶)四種鹼基、糖及磷酸構成的核苷酸，由30億個鹼基對構成雙重螺旋。在DNA中，持有情報訊息的領域稱為生命的設計圖，被稱為「基因」，是合成蛋白質的基礎。但是，「基因」僅佔全體DNA的2%。
                </p>
              </div>
            </div>
          </div>
        </section> -->
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Dựa vào thông tin di truyền của DNA<!--以DNA的遺傳信息為基礎-->
              <br />
              “RNA” tham gia vào quá trình tổng hợp protein<!--參與蛋白質合成的「RNA」-->
            </h2>
            <div class="row align-items-center mb-md-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/kakusan/img_about06.jpg"
                  alt
                  class="w-100"
                />
              </div>
              <div class="col-md-6">
                <p>
                  Thông tin trình tự của các “axit amin” là khối xây dựng của protein được sao chép vào “gen” của DNA. 
                  Thông tin di truyền này được sao chép vào RNA và một số loại RNA sau đó nối các axit amin lại với nhau để tạo ra protein.
                  <!--作為蛋白質構成成分的「胺基酸」，其序列信息被抄寫在DNA的「基因」中。這些遺傳信息會被複製到RNA，之後由數種類型的RNA將胺基酸連接，製造出蛋白質。-->
                  <br />
                  Kể từ khi giải mã gen người, nghiên cứu gần đây đã tiết lộ rằng RNA không chỉ có chức năng tổng hợp protein mà một 
                  số RNA nhất định còn có chức năng kiểm soát biểu hiện gen, điều này đã thu hút nhiều sự chú ý.
                  <!--自人類基因解碼以來，近年的研究得知RNA不只有合成蛋白質的功能，更發現某些RNA具有控制基因表現的作用，備受矚目。-->
                </p>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Hai cách tổng hợp axit nucleic (DNA‧RNA)<!--合成核酸(DNA‧RNA)的兩種路徑-->
            </h2>
            <div class="row">
              <div class="col-md-12">
                <p>
                  Các thành phần axit nucleic cần thiết cho tế bào được tổng hợp trong cơ thể thông qua hai con đường.<br />
                  Một là tổng hợp axit nucleic mới trong gan bằng cách sử dụng axit amin hoặc đường (carbohydrate) làm nguyên liệu thô, được gọi là "tổng hợp de novo".<br />
                  Loại còn lại là "tổng hợp tận dụng", tổng hợp axit nucleic thông qua axit nucleic ăn vào từ thức ăn hoặc bằng cách tái sử dụng các thành 
                  phần axit nucleic không cần thiết trong cơ thể. Và khả năng “tái tổng hợp” sẽ suy giảm theo tuổi tác, khiến các hoạt động của tế bào không 
                  thể diễn ra suôn sẻ. Vì vậy, để duy trì sức khỏe và sắc đẹp, việc tích cực hấp thụ axit nucleic từ thực phẩm là rất quan trọng.
                </p>
                <!--
                <p>
                  細胞需要的核酸成分在體內透過兩種途徑合成。<br />
                  一種是在肝臟內以胺基酸或糖(碳水化合物)等為原料來合成新的核酸，稱為「重新合成」。<br />
                  另一種是經由食物中所攝取的核酸或將體內不需要的核酸成分再利用來合成核酸的「打撈合成」。而「重新合成」會隨著年齡增長而衰退，使細胞的活動無法順利進行。因此，為了維持健康與美麗，積極從食物中攝取核酸是很重要的一件事。
                </p>
                -->
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Thực phẩm giàu axit nucleic<!--富含核酸的食品-->
            </h2>
            <div class="row align-items-center">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/kakusan/img_about07.jpg"
                  alt
                  class="w-100"
                />
              </div>
              <div class="col-md-6">
                <p>
                  Tất cả các loại thực phẩm đều chứa axit nucleic, đặc biệt là các nguồn protein quan trọng như thịt, cá, 
                  động vật có vỏ và đậu, về cơ bản chứa một lượng lớn axit nucleic. Trong số tất cả các loại thực phẩm, 
                  tinh hoàn cá hồi có hàm lượng axit nucleic cao nhất, tiếp đến là nấm men ăn được. Nghêu, hàu, rong biển, 
                  đậu nành, thịt gà và gan lợn cũng là những thực phẩm giàu axit nucleic. Tất nhiên, không chỉ cần bổ sung axit nucleic, 
                  điều quan trọng là phải bổ sung cân bằng các chất dinh dưỡng cần thiết cho cơ thể. Chú ý đến một chế độ ăn uống 
                  cân bằng khi lượng ăn vào không đủ, nên sử dụng thực phẩm bổ sung như một chất bổ sung để có một cuộc sống khỏe mạnh mỗi ngày.
                  <!--所有食物都含有核酸，特別是重要的蛋白質來源，如肉類、魚貝類和豆類等，基本上都含有大量的核酸。而所有食品中核酸含量最高的是鮭魚精巢，
                  其次是食用酵母，還有蛤蜊、牡蠣、海苔、大豆、雞肉以及豬肝等也都是富含核酸的食品。當然，並不是只需要攝取核酸就好，重要的是要均衡攝取身體所需的營養素。
                  注意均衡的飲食生活，當攝取不足的時候，建議可搭配營養補助品來做為輔助，度過健康的每一天。-->
                </p>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <p class="text-center">
              Gen Thế giới của axit nucleic Video giải thích<!--遺伝子 核酸の世界 解説動画-->
            </p>
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-8">
                <iframe
                  width="100%"
                  height="415"
                  src="https://www.youtube.com/embed/RQaeUY70aoA"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/KakusanHeaderNav";
export default {
  name: "KakusanScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
